function Profile() {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-3xl font-bold">User Profile</h1>
        <p className="text-gray-700 mt-2">Manage your account here.</p>
      </div>
    );
  }
  
  export default Profile;
  